(function(){
  'use strict';
  angular
    .module('irricrops', [
        'ngRaven',
        'ngResource',
        'ngMaterial',
        'ngAnimate',
        'ui.router',
        'ngTinyScrollbar',
        'highcharts-ng',
        'angularMoment',
        'ngStorage',
        'ngSanitize',
        'ngFileUpload',
        'angulartics',
        'angulartics.google.analytics',
        // 'angulartics.mixpanel',
        'uiGmapgoogle-maps',
        'ng.deviceDetector',
    ])
    .constant('angularMomentConfig', {
      timezone: 'America/Santiago' // e.g. 'Europe/London'
    })
  .config(["uiGmapGoogleMapApiProvider",function(uiGmapGoogleMapApiProvider) {
    uiGmapGoogleMapApiProvider.configure({
      key       : 'AIzaSyBUMx9F4Cdct03rju3sXei7pmnrf4pH1pA',
      v         : '3.20', //defaults to latest 3.X anyhow
      libraries : 'places,drawing'
    });
  }])

    .config(['$sceDelegateProvider', function($sceDelegateProvider) {
      $sceDelegateProvider.resourceUrlWhitelist([
        // Allow same origin resource loads.
        'self',
        // Allow loading from our assets domain.  Notice the difference between * and **.
        'http://bg.siteorigin.com**']);
    }])

  .config(['$compileProvider', "urls",function ($compileProvider, urls) {

    if(location.host == urls.PRODUCTION_HOST_NAME){
      $compileProvider.debugInfoEnabled(false);
      window.onbeforeunload_dep = function (e) {
        e = e || window.event;

        // For IE and Firefox prior to version 4
        if (e) {
          e.returnValue = '¿Seguro que desea cerrar la pestaña';
        }

        // For Safari
        return '¿Seguro que desea cerrar la pestaña';
      };
    }
  }])

  .config(['$mdDateLocaleProvider',function($mdDateLocaleProvider) {
    $mdDateLocaleProvider.firstDayOfWeek = 1;

    // Example uses moment.js to parse and format dates.
    $mdDateLocaleProvider.parseDate = function(dateString) {
      var m = moment(dateString, 'DD/MM/YYYY', true);
      if(!m.isValid()){
        m = moment(dateString, 'YYYY-MM-DD', true);
      }
      if(!m.isValid()){
        m = moment(dateString);
      }
      return m.isValid() ? m.toDate() : null;
    } ;

    $mdDateLocaleProvider.formatDate = function(date) {
      var m = moment(date);
      return m.isValid() ? m.format('DD/MM/YYYY') : '';
    };


    Highcharts.setOptions({

      global: {
        useUTC: false,
      },
      time:{
        timezone: 'America/Santiago'
      },
      lang           : {
        months       : ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
        shortMonths  : ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
        weekdays     : ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
        resetZoom    : 'Ver gráfico completo',
        decimalPoint : ',',
        printChart   : "Imprimir Gráfico",
        downloadJPEG : "Descargar JPG",
        downloadPDF  : "Descargar PDF",
        downloadSVG  : "Descargar SVG",
        downloadPNG  : "Descargar Imagen"
      }
    });



  }])


  .config(['$analyticsProvider', function ($analyticsProvider) {
    $analyticsProvider.firstPageview(true); /* Records pages that don't use $state or $route */
    $analyticsProvider.withAutoBase(true);  /* Records full path */
  }])


  .config(['$mdThemingProvider', '$mdIconProvider', '$httpProvider',
      function($mdThemingProvider, $mdIconProvider, $httpProvider){

        //escucha si hay cambio de tema
        //$mdThemingProvider.alwaysWatchTheme(true);

        //iconos usados en la plataforma
        $mdIconProvider
          .defaultIconSet("./assets/svg/avatars.svg", 128)
          .icon("menu" ,"./assets/svg/menu.svg", 24)
          .icon("irri-logo" , "./assets/svg/logo-grey.svg", 24)
          .icon("irri-logo-white" , "./assets/svg/logo-white.svg", 24);


        //define los colores del tema, para el color primario(primary)
        //y color de acentuacion(accent)
        $mdThemingProvider.theme('default')
          .primaryPalette('green', {
            'default' : '800',
            'hue-1'   : '100', // use shade 100 for the <code>md-hue-1</code> class
            'hue-2'   : '600', // use shade 600 for the <code>md-hue-2</code> class
            'hue-3'   : 'A100' // use shade A100 for the <code>md-hue-3</code> class
          })
        .accentPalette('pink', {'default':'600'});

        // $mdThemingProvider.theme('altTheme')
        //   .primaryPalette('blue', {
        //     'default': '700', // by default use shade 400 from the pink palette for primary intentions
        //     'hue-1': '100', // use shade 100 for the <code>md-hue-1</code> class
        //     'hue-2': '600', // use shade 600 for the <code>md-hue-2</code> class
        //     'hue-3': 'A100' // use shade A100 for the <code>md-hue-3</code> class
        // })
        // .accentPalette('pink', {'default':'600'});

        /*
        $mdThemingProvider.enableBrowserColor({
          theme: 'default', // Default is 'default'
          palette: 'primary', // Default is 'primary', any basic material palette and extended palettes are available
          hue: '800' // Default is '800'
        });
        */



        Highcharts.theme = {
          colors: [
            '#f44336',
            '#9c27b0',
            '#3F51B5',
            '#2196F3',
            '#009688',
            '#795548',
            '#455A64'
          ],
          chart: {
            backgroundColor: null,
            style: {
              fontFamily: 'roboto, sans serif'
            }
          },
          title: {
            style: {
              color: 'black',
              fontSize: '16px',
              fontWeight: 'bold'
            }
          },
          subtitle: {
            style: {
              color: 'black'
            }
          },
          tooltip: {
            borderWidth: 0
          },
          legend: {
            itemStyle: {
              fontWeight: 'bold',
              fontSize: '13px'
            }
          },
          xAxis: {
            labels: {
              style: {
                color: '#6e6e70'
              }
            }
          },
          yAxis: {
            labels: {
              style: {
                color: '#6e6e70'
              }
            }
          },
          plotOptions: {
            series: {
              shadow: false
            },
            candlestick: {
              lineColor: '#404048'
            },
            map: {
              shadow: false
            }
          },

          // Highstock specific
          navigator: {
            xAxis: {
              gridLineColor: '#D0D0D8'
            }
          },
          rangeSelector: {
            buttonTheme: {
              fill: 'white',
              stroke: '#C0C0C8',
              'stroke-width': 1,
              states: {
                select: {
                  fill: '#D0D0D8'
                }
              }
            }
          },
          scrollbar: {
            trackBorderColor: '#C0C0C8'
          },

          // General
          background2: '#E0E0E8'

        };
        Highcharts.setOptions(Highcharts.theme);


        /**
         * interceptor de peticiones
         * antes de enviar una peticion, anida el token de la sesion
         */
        $httpProvider.interceptors.push(['$q','$localStorage', '$injector', function ($q, $localStorage, $injector) {
          return {
            'request': function (config) {
              config.headers = config.headers || {};
              if ($localStorage.token){
                config.headers.Authorization = 'Bearer ' + $localStorage.token;
              }
              if (config.url.split("hooks.slack.com").length > 1 ){
                config.headers = {};
              }
              return config;
            },
            'responseError': function (response) {
              if ($.inArray(response.status, [401]) > -1) {
                mixpanel.track("kickout");
                var $st = $injector.get('$state');
                if($st.current.name != "login"){
                  var url = window.location.href;
                  url = url.split("#")[1];
                  $st.go("login");
                }
              }
              // if ($.inArray(response.status, [403]) > -1) {
              //   $injector.get('$state').go("403");
              // }
              // if ($.inArray(response.status, [404]) > -1) {
              //   $injector.get('$state').go("404");
              // }
              return $q.reject(response);
            }
          };
        }]);




      }])




  //Por orden de prioridad, primeros los config, luego los run
    .run(["$animate",function($animate) {
      $animate.enabled(false);
    }])


      .run(['amMoment',function(amMoment) {
        amMoment.changeLocale('es');
        //console.log("%cSi ves esto, puedes ser la persona que buscamos", "background: red; color: yellow; font-size: x-large");
      }])


      .run(['$location', 'urls', function($location, urls){
        if($location.$$host == urls.PRODUCTION_HOST_NAME){
          //
        }else{
          mixpanel.disable();
          console.log('disable mixpanel');
        }
      }])

      .run(['menu', 'temporadaFac', function(menu, temporadaFac) {
        return menu.getMe().then(() => {
          var a = temporadaFac.getTemporadas();
          return a;
        })
      }])

})();
